import Marquee from "react-fast-marquee";

const ITEMS = [
  "Air Freight",
  "Ocean Freight",
  "Land Transport",
  "Customs Clearance",
  "Warehousing",
];

export function EditorialMarquee() {
  return (
    <section
      data-testid="services-marquee"
      aria-label="Our disciplines"
      className="overflow-hidden border-y border-white/10 py-8 lg:py-10"
    >
      <Marquee speed={32} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center">
            <span className="text-outline px-10 font-display text-5xl font-medium uppercase tracking-tight transition-[color] duration-300 hover:text-[#FF3B30] md:text-7xl lg:px-14">
              {item}
            </span>
            <span className="h-3 w-3 shrink-0 bg-[#FF3B30]" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
